import React from 'react';

const InfoLabel = () => (
  <p>
    The Insured ID can be found in the URL in the insured profile page (i.e. https://portal.pinsadvantage.com/v2/companies/27270/
    <span style={{ fontWeight: 'bolder', textDecoration: 'underline' }}>insureds/238010</span>
    ).
  </p>
);

export default InfoLabel;
